import {
  getGridStringOperators,
  GridColDef,
  GridValidRowModel,
} from '@mui/x-data-grid-pro';
import { ComparisonOperatorEnum } from '@src/types/ComparisonOperators';

export default function generateDataPointSearchColumns(
  _handleDetailsClick: (gridRow: GridValidRowModel) => () => void, // may be used in the future
): GridColDef[] {
  const stringFilterOperator = {
    operators: getGridStringOperators().filter(
      (operator) => operator.value === ComparisonOperatorEnum.EQUALS,
    ),
  };

  const DataPointSearchGridColumns: GridColDef[] = [];

  const topicColumn: GridColDef = {
    field: 'topic',
    headerName: 'Topic',
    flex: 3,
    filterOperators: stringFilterOperator.operators,
  };

  const parentDeviceIDColumn: GridColDef = {
    field: 'parentDeviceId',
    headerName: 'Parent Device',
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const deviceTypeColumn: GridColDef = {
    field: 'deviceType',
    headerName: 'Device Type',
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const deviceIDColumn: GridColDef = {
    field: 'deviceId',
    headerName: 'Device ID',
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const pointNameColumn: GridColDef = {
    field: 'pointName',
    headerName: 'Point Name',
    flex: 3,
    filterOperators: stringFilterOperator.operators,
  };

  DataPointSearchGridColumns.push(
    topicColumn,
    parentDeviceIDColumn,
    deviceTypeColumn,
    deviceIDColumn,
    pointNameColumn,
  );

  return DataPointSearchGridColumns;
}
